<template functional>
  <div class="relation-separator">
    <span>
      {{ props.condition === 'allOf' ? 'and' : 'or' }}
    </span>
  </div>
</template>

<script>
export default {
  props: {
    condition: {
      type: String,
      required: true,
    },
  },
}
</script>

<style lang="scss" scoped>
.relation-separator {
  text-align: center;
  position: relative;
  z-index: 0;
  margin-left: 2rem;
  margin-right: 2rem;

  span {
    display: inline-block;
    position: relative;
    padding: 4px;
    background: white;
    z-index: 1;
    text-transform: uppercase;
    font-weight: 600;
  }

  &:after {
    content: '';
    position: absolute;
    top: 50%;
    display: block;
    width: 100%;
    z-index: -1;
    border-bottom: 1px solid var(--dark-gray);
  }
}
</style>
